import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { always, compose, pathOr, when, equals } from 'ramda';

import { Container, Img, ContainerBackground } from './lazyLoadImage.styles';
import { getImgSrcSetProps } from '../../utils/contentfulImages';
import { renderWhenNotNil } from '../../utils/rendering';

const getRatio = ({ width = 0, height = 0 }) => height / width;

export class LazyLoadImage extends PureComponent {
  static propTypes = {
    imgProps: PropTypes.object,
    sizes: PropTypes.array,
    file: PropTypes.object,
    className: PropTypes.any,
    placeholderStyle: PropTypes.any,
    imgStyle: PropTypes.any,
    disableRatioCalculation: PropTypes.bool,
    ratio: PropTypes.number,
  };

  static defaultProps = {
    sizes: [],
    file: {},
  };

  state = {
    loaded: false,
  };

  get ratio() {
    if (this.props.disableRatioCalculation) {
      return 0;
    }

    return compose(
      when(equals(NaN), always(this.props.ratio)),
      getRatio,
      pathOr({}, ['details', 'image'])
    )(this.props.file);
  }

  handleLoad = () => this.setState({ loaded: true });

  renderBackground = () => <ContainerBackground ratio={this.ratio} extraStyle={this.props.placeholderStyle} />;

  renderImage = renderWhenNotNil(() => (
    <Img
      onLoad={this.handleLoad}
      visible={this.state.loaded}
      extraStyle={this.props.imgStyle}
      {...this.props.imgProps}
      {...getImgSrcSetProps(this.props.file.url, this.props.sizes)}
    />
  ));

  render() {
    return (
      <Container className={this.props.className}>
        {this.renderBackground()}
        {this.renderImage(this.props.file.url)}
      </Container>
    );
  }
}
